import React from 'react'

import '../styles/main.css'
import FormEnterpriceSign from '../../components/Login/FormEnterpriceSign'

function Main() {

    return (

        <main className='--main'>

            <div className='--content-main--login'>

                <div className='--box-main--login'>

                    <div className='--col-main--login'>

                        <div className='--col-main--login-center'>
                        
                            <h1>Crea tu cuenta de empresa</h1>
                            <p>¡Hola! Accede y encuentra el trabajo que buscas</p>

                            <div className='--line'></div>

                            <FormEnterpriceSign/>

                        </div>

                    </div>

                </div>

            </div>

        </main>

    )

}

export default Main